module.exports = __webpack_public_path__ + "static/img/help.06485d25.svg";